import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { EmailDirectoryListItem } from 'app/models/dto/directory-list-item.model';
import { map, startWith } from 'rxjs/operators';

@Component({
  selector: 'app-lendio-directory-dialog',
  templateUrl: './lendio-directory-dialog.component.html',
  styleUrls: ['./lendio-directory-dialog.component.scss']
})

export class LendioDirectoryDialogComponent implements OnInit {

  autocompleteHeight: string = '200px';
  control = new UntypedFormControl();
  filteredLendions: EmailDirectoryListItem[];

  constructor(
    @Inject(MAT_DIALOG_DATA) public lendioEmailDirectory: EmailDirectoryListItem[],
    private dialogRef: MatDialogRef<LendioDirectoryDialogComponent>,
  ) { }

  ngOnInit(): void {
    this.filteredLendions = this.findThatLendion('');
    this.setupFiltering();
  }

  setupFiltering(): void {
        // Listen for changes to the search input
        this.control.valueChanges
        .pipe(
          startWith(''),
          map(value => {
            // Filter the options
            this.filteredLendions = this.findThatLendion(value);
    
            // Recompute how big the viewport should be.
            if (this.filteredLendions.length < 4) {
              this.autocompleteHeight = (this.filteredLendions.length * 50) + 'px';
            } else {
              this.autocompleteHeight = '200px';
            }
          })
        ).subscribe();
  }
  
  close() {
    this.dialogRef.close(null);
  }
  
  addLendionRecipient(lendion: EmailDirectoryListItem) {
    this.dialogRef.close(lendion);
  }
  
  private findThatLendion(searchValue: string): EmailDirectoryListItem[] {
      return this.lendioEmailDirectory.filter((lendion) => {
        return lendion.fullName.toLowerCase().startsWith(searchValue.toLowerCase());
      });
  }

}
